var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "number-info",
      class:
        ((_obj = {}), (_obj["number-info-" + _vm.theme] = _vm.theme), _obj),
    },
    [
      _vm.title || this.$slots.title
        ? _c(
            "div",
            { staticClass: "number-info-title" },
            [
              _vm.title
                ? [_vm._v(" " + _vm._s(_vm.title) + " ")]
                : [_vm._t("title")],
            ],
            2
          )
        : _vm._e(),
      _vm.subTitle || this.$slots.subTitle
        ? _c(
            "div",
            { staticClass: "number-info-sub-title" },
            [
              _vm.subTitle
                ? [_vm._v(" " + _vm._s(_vm.subTitle) + " ")]
                : [_vm._t("subTitle")],
            ],
            2
          )
        : _vm._e(),
      _c("div", { staticClass: "number-info-value", style: _vm.gapStyle }, [
        _c(
          "span",
          [
            _vm._v(" " + _vm._s(_vm.total && _vm.total) + " "),
            _vm.$slots.total ? _vm._t("total") : _vm._e(),
            _vm.suffix || this.$slots.suffix
              ? _c(
                  "em",
                  { staticClass: "suffix" },
                  [
                    _vm._v(" " + _vm._s(_vm.suffix && _vm.suffix) + " "),
                    _vm.$slots.suffix ? _vm._t("suffix") : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
          ],
          2
        ),
        _vm.status || _vm.subTotal
          ? _c(
              "span",
              { staticClass: "sub-total" },
              [
                _vm._v(" " + _vm._s(_vm.subTotal) + " "),
                _vm.status
                  ? _c("ant-icon", { attrs: { type: "caret-" + _vm.status } })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }